// estados por defectos para mensajes (varaibles globales en el store  de mensajeria)
export default {
    // para sirve para acceder  mapstate de la siguiente forma para lso modulos ...(mapState 'mensaje', ['mensaje'])
    namespaced: true,

    state: {

      wizardActivo: false,
        datos:{
            evento:"agregar",
            params: {},
            index: -1
        },

    },
    // cambia los estados de las variables principales
    // de las variables princiaples

    mutations: {
    
        setEvent(state, datos) {
          
            // pasa de verdadero a falso o visiversa

            state.wizardActivo   = !state.wizardActivo;
            state.datos.evento = datos.evento == null || datos.evento == "" ? null : datos.evento; 
            state.datos.index  = datos.index == null || datos.index == "" ? null : datos.index;
            state.datos.params = datos.params == null || datos.params == "" ? null : datos.params;
        },

    },

    // crea una copía de los estado iniciales del store (state)

    getters: {
        wizardEvent: (state) => {
            return state.datos;
        },

        wizardActivo: (state) => {
          return state.wizardActivo;
      },
    },

    actions: {},
}

  /*
      /////////////////////
      ////  Aplicando   ///
      ////////////////////
      import {mapMutations, mapState} from 'vuex'

      data: () => ({

      methods: {
              ...mapMutations('wizard', ['setEvent']),
              loadEvento() {
                  this.setEvent(evento, index, params )
              },

        computed: {

            ...mapGetters('wizard', ['wizardEvent']),
           

        }
  */
